<template>
    <div class="lint-one-element">
        <loader v-if="isDocLoading" style="z-index:10000" object="#344767" color1="#ffffff" color2="#2152ff" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" name="circular"></loader>
        
        <!-- Alerts -->
        <vsud-alert v-if="isSubmitted" icon="fa fa-bell" :dismissible="true" :color="alertColor">
            {{ alertMessage }}
        </vsud-alert>

        <div class="py-4 container-fluid">
            <div class="row">
            <div class="col-12">
<!-- Header Card -->
                    <div class="card mb-4 header-card">
                        <div class="card-body py-3 px-4">
                            <div class="row align-items-center">
                                <div class="col-md-6">
                                    <div class="d-flex align-items-center">
                                        <div class="me-3">
                                            <img :src="getPhotoUrl(primaryPhoto)" class="avatar avatar-lg rounded-circle border shadow-sm" @error="handleImageError" />
                        </div>
                                        <div>
                                            <h5 class="mb-1 fw-bold">{{ viewData.firstName }} {{ viewData.lastName }}</h5>
                                            <div class="d-flex align-items-center flex-wrap gap-2">
                                                <span class="text-info fw-semibold small">{{ getPensionId(viewData) || 'N/A' }}</span>
                                                <vsud-badge :color="renderStatus(viewData.status, 'color')" variant="gradient" size="sm">
                                                    {{ renderStatus(viewData.status) }}
                                                </vsud-badge>
                                                <vsud-badge v-if="viewData.subStatus && viewData.status !== 'completed'" 
                                                    :color="getSubStatusColor(viewData.subStatus)" 
                                                    variant="gradient" size="sm">
                                                    {{ formatSubStatus(viewData.subStatus) }}
                                                </vsud-badge>
                        </div>
                        </div>
                    </div>
                                </div>
                                <div class="col-md-6 text-end mt-3 mt-md-0">
                                    <div class="d-inline-flex align-items-center gap-2">
                                        <div class="btn-group" role="group">
                                            <button type="button" 
                                                :class="['btn', activeView === 'summary' ? 'bg-gradient-info text-white' : 'btn-outline-info']"
                                                @click="setActiveView('summary')">
                                                <i class="fas fa-file-alt me-1"></i> View Summary
                                            </button>
                                            <button type="button" 
                                                :class="['btn', activeView === 'details' ? 'bg-gradient-info text-white' : 'btn-outline-info']"
                                                @click="setActiveView('details')">
                                                <i class="fas fa-eye me-1"></i> View Details
                                            </button>
                                        </div>
                                        <router-link :to="{ name: 'Pensioners' }" class="btn btn-outline-secondary">
                                            <i class="fas fa-times me-1"></i> Close
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                                </div>
                                </div>

                    <!-- Main Content -->
                    <div v-if="isLoading === false && message === ''">
                        
                        <!-- VIEW SUMMARY -->
                        <div v-if="activeView === 'summary'" class="card" id="printable-summary">
                            <div class="card-header d-flex justify-content-between align-items-center">
                                <h6 class="mb-0"><i class="fas fa-file-alt me-2"></i>Pensioner Summary</h6>
                                <button class="btn btn-sm bg-gradient-success" @click="printSummary">
                                    <i class="fas fa-print me-1"></i> Print PDF
                                </button>
                            </div>
                            <div class="card-body">
                                <!-- Print Header (Hidden on screen, visible on print) -->
                                <div class="print-header text-center mb-4">
                                    <h4 class="text-uppercase mb-1">KATSINA STATE GOVERNMENT</h4>
                                    <p class="mb-1">State and Local Government Pension Digital Verification Exercise</p>
                                    <hr class="my-2">
                                </div>

                                <div class="row">
                                    <!-- Photo Section -->
                                    <div class="col-md-3 text-center mb-4">
                                        <div class="photo-container">
                                            <img :src="getPhotoUrl(primaryPhoto)" 
                                                class="img-fluid rounded border shadow-sm" 
                                                style="max-height: 200px; object-fit: cover;"
                                                @error="handleImageError" />
                                        </div>
                                        <div class="mt-2">
                                            <vsud-badge :color="viewData.isLga == 1 ? 'info' : 'warning'" variant="gradient" size="sm">
                                                {{ viewData.isLga == 1 ? 'LGA Pensioner' : 'State Pensioner' }}
                                        </vsud-badge>
                                </div>
                            </div>

                                    <!-- Combined Personal & Employment Info -->
                                    <div class="col-md-9">
<!-- Personal Information -->
                                        <div class="info-section mb-4">
                                            <h6 class="section-title section-personal text-white px-3 py-2 rounded-top mb-0">
                                                <i class="fas fa-user me-2"></i>Personal Information
                                    </h6>
                                            <div class="table-responsive border border-top-0 rounded-bottom">
                                                <table class="table table-sm mb-0">
                                        <tbody>
                                            <tr> 
                                                            <td class="bg-light" width="25%"><strong>Full Name</strong></td>
                                                            <td>{{ viewData.firstName }} {{ viewData.lastName }}</td>
                                                            <td class="bg-light" width="25%"><strong>Gender</strong></td>
                                                            <td>{{ viewData.gender || '—' }}</td>
                                            </tr>
                                            <tr> 
                                                            <td class="bg-light"><strong>Date of Birth</strong></td>
                                                            <td>{{ formatDate(viewData.dateOfBirth) }}</td>
                                                            <td class="bg-light"><strong>Phone No.</strong></td>
                                                            <td>{{ viewData.phoneNo || '—' }}</td>
                                            </tr>
                                            <tr> 
                                                            <td class="bg-light"><strong>State of Origin</strong></td>
                                                            <td>Katsina</td>
                                                            <td class="bg-light"><strong>LGA</strong></td>
                                                            <td>{{ viewData.lga || '—' }}</td>
                                            </tr>
                                            <tr>
                                                            <td class="bg-light"><strong>Marital Status</strong></td>
                                                            <td>{{ viewData.maritalStatus || '—' }}</td>
                                                            <td class="bg-light"><strong>Email</strong></td>
                                                            <td>{{ viewData.emailAddress || '—' }}</td>
                                            </tr>
                                            <tr>
                                                            <td class="bg-light"><strong>Permanent Address</strong></td>
                                                            <td colspan="3">{{ viewData.address || '—' }}</td>
                                            </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <!-- Banking Information -->
                                        <div class="info-section mb-4">
                                            <h6 class="section-title section-banking text-white px-3 py-2 rounded-top mb-0">
                                                <i class="fas fa-university me-2"></i>Banking Details
                                            </h6>
                                            <div class="table-responsive border border-top-0 rounded-bottom">
                                                <table class="table table-sm mb-0">
                                                    <tbody>
                                                        <tr>
                                                            <td class="bg-light" width="25%"><strong>Bank Name</strong></td>
                                                            <td>{{ viewData.bankName || '—' }}</td>
                                                            <td class="bg-light" width="25%"><strong>Account No.</strong></td>
                                                            <td>{{ viewData.accountNumber || '—' }}</td>
                                            </tr>
                                            <tr>
                                                            <td class="bg-light"><strong>BVN</strong></td>
                                                            <td>{{ viewData.bvn || '—' }}</td>
                                                            <td class="bg-light"><strong>NIN</strong></td>
                                                            <td>{{ viewData.nin || '—' }}</td>
                                            </tr>
                                        </tbody>
                                        </table>
                                    </div>
                                </div>

                                        <!-- Employment Records -->
                                        <div class="info-section mb-4">
                                            <h6 class="section-title section-employment text-white px-3 py-2 rounded-top mb-0">
                                                <i class="fas fa-briefcase me-2"></i>Employment Records
                                            </h6>
                                            <div class="table-responsive border border-top-0 rounded-bottom">
                                                <table class="table table-sm mb-0">
                                        <tbody>
                                            <tr>
                                                            <td class="bg-light" width="25%"><strong>Ministry/LG</strong></td>
                                                            <td>{{ viewData.ministryOnRetirement || '—' }}</td>
                                                            <td class="bg-light" width="25%"><strong>Department</strong></td>
                                                            <td>{{ viewData.departmentOnRetirement || '—' }}</td>
                                            </tr>
                                            <tr>
                                                            <td class="bg-light"><strong>Designation</strong></td>
                                                            <td>{{ viewData.designationOnRetirement || '—' }}</td>
                                                            <td class="bg-light"><strong>Grade Level</strong></td>
                                                            <td>{{ viewData.gradeLevel || '—' }}</td>
                                            </tr>
                                            <tr>
                                                            <td class="bg-light"><strong>Date of First Appt.</strong></td>
                                                            <td>{{ formatDate(viewData.dateOfFirstAppointment) }}</td>
                                                            <td class="bg-light"><strong>Retirement Date</strong></td>
                                                            <td>{{ formatDate(viewData.retirementDate) }}</td>
                                            </tr>
                                            <tr>
                                                            <td class="bg-light"><strong>Pension ID</strong></td>
                                                            <td class="text-info fw-bold">{{ getPensionId(viewData) || '—' }}</td>
                                                            <td class="bg-light"><strong>Monthly Pension</strong></td>
                                                            <td class="text-success fw-bold">₦{{ formatCurrency(viewData.monthlyPension) }}</td>
                                            </tr>
                                        </tbody>
                                        </table>
                                </div>
                            </div>

<!-- Next of Kin -->
                                        <div class="info-section">
                                            <h6 class="section-title section-nok text-white px-3 py-2 rounded-top mb-0">
                                                <i class="fas fa-users me-2"></i>Next of Kin Details
                                    </h6>
                                            <div class="table-responsive border border-top-0 rounded-bottom">
                                                <table class="table table-sm mb-0">
                                        <tbody>
                                            <tr> 
                                                            <td class="bg-light" width="25%"><strong>Name</strong></td>
                                                            <td>{{ viewData.nokFirstName }} {{ viewData.nokLastName }}</td>
                                                            <td class="bg-light" width="25%"><strong>Relationship</strong></td>
                                                            <td>{{ viewData.nokRelationship || '—' }}</td>
                                            </tr>
                                            <tr> 
                                                            <td class="bg-light"><strong>Phone</strong></td>
                                                            <td>{{ viewData.nokPhone || '—' }}</td>
                                                            <td class="bg-light"><strong>Address</strong></td>
                                                            <td>{{ viewData.nokAddress || '—' }}</td>
                                            </tr>
                                        </tbody>
                                        </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- VIEW DETAILS -->
                        <div v-if="activeView === 'details'">
                            <div class="row">
                                <!-- Left Column: Review Panel -->
                                <div class="col-md-4">
                                    <!-- Review Panel Card -->
                                    <div class="card mb-4">
                                        <div class="card-header">
                                            <h6 class="mb-0"><i class="fas fa-clipboard-check me-2"></i>Review Panel</h6>
                                        </div>
                                        <div class="card-body">
                                            <!-- Enrolled By -->
                                            <div class="mb-3">
                                                <label class="text-xs text-muted text-uppercase">Enrolled By</label>
                                                <p class="mb-0 fw-bold">{{ viewData.enrolledBy || 'System Import' }}</p>
                                            </div>

                                            <!-- BVN with Invalidate -->
                                            <div class="mb-3">
                                                <label class="text-xs text-muted text-uppercase">BVN</label>
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <span class="fw-bold">{{ viewData.bvn || '—' }}</span>
                                                    <button v-if="viewData.bvn && (userClass === 'admin' || userClass === 'superadmin')" 
                                                        class="btn btn-xs btn-outline-danger"
                                                        @click="showInvalidateBvnModal = true">
                                                        Invalidate BVN
                                                    </button>
                                                </div>
                                            </div>

                                            <hr>

                                            <!-- Status Management -->
                                            <div class="mb-3">
                                                <label class="text-xs text-muted text-uppercase">Change Status</label>
                                                <div class="d-grid gap-2 mt-2">
                                                    <button class="btn btn-sm bg-gradient-success" @click="showChangeStepModal = true">
                                                        <i class="fas fa-exchange-alt me-1"></i> Change Step
                                                    </button>
                                                    <button class="btn btn-sm bg-gradient-warning" @click="showChangeSubStatusModal = true"
                                                        :disabled="viewData.status === 'completed'">
                                                        <i class="fas fa-tag me-1"></i> Change Sub-Status
                                                    </button>
                                                </div>
                                            </div>

                                            <hr>

                                            <!-- Quick Actions -->
                                            <div class="mb-3">
                                                <label class="text-xs text-muted text-uppercase">Quick Actions</label>
                                                <div class="d-grid gap-2 mt-2">
                                                    <button class="btn btn-sm bg-gradient-info" @click="generateAcknowledgementSlip">
                                                        <i class="fas fa-file-pdf me-1"></i> Acknowledgement Slip
                                                    </button>
                                                    <button class="btn btn-sm bg-gradient-dark" @click="printSummary">
                                                        <i class="fas fa-print me-1"></i> Full Pensioner Details
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Employment Records Card -->
                                    <div class="card mb-4">
                                        <div class="card-header d-flex justify-content-between align-items-center">
                                            <h6 class="mb-0"><i class="fas fa-briefcase me-2"></i>Employment Record</h6>
                                            <vsud-badge :color="viewData.isLga == 1 ? 'info' : 'warning'" variant="gradient" size="sm">
                                                {{ viewData.isLga == 1 ? 'LG Record' : 'State Record' }}
                                            </vsud-badge>
                                        </div>
                                        <div class="card-body">
                                            <div class="mb-2">
                                                <label class="text-xs text-muted">Ministry/LG</label>
                                                <p class="mb-1 fw-bold">{{ viewData.ministryOnRetirement || '—' }}</p>
                                            </div>
                                            <div class="mb-2">
                                                <label class="text-xs text-muted">Department</label>
                                                <p class="mb-1">{{ viewData.departmentOnRetirement || '—' }}</p>
                                            </div>
                                            <div class="row">
                                                <div class="col-6">
                                                    <label class="text-xs text-muted">Grade Level</label>
                                                    <p class="mb-1">{{ viewData.gradeLevel || '—' }}</p>
                                                </div>
                                                <div class="col-6">
                                                    <label class="text-xs text-muted">Date</label>
                                                    <p class="mb-1 small">{{ formatDate(viewData.dateOfFirstAppointment) }} - {{ formatDate(viewData.retirementDate) }}</p>
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-6">
                                                    <label class="text-xs text-muted">Monthly Pension</label>
                                                    <p class="mb-0 text-success fw-bold">₦{{ formatCurrency(viewData.monthlyPension) }}</p>
                                                </div>
                                                <div class="col-6">
                                                    <label class="text-xs text-muted">Updated At</label>
                                                    <p class="mb-0 small">{{ formatDate(viewData.updatedAt) }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Right Column: Detailed Information -->
                                <div class="col-md-8">
                                    <!-- BVN Details -->
                                    <div class="card mb-4 card-bvn">
                                        <div class="card-header header-bvn">
                                            <h6 class="mb-0 text-dark"><i class="fas fa-id-card me-2"></i>Verified BVN Details</h6>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-md-3 text-center">
                                                    <img :src="getPhotoUrl(primaryPhoto)" class="img-fluid rounded border" style="max-height: 150px;" @error="handleImageError" />
                                                </div>
                                                <div class="col-md-9">
                                                    <div class="row">
                                                        <div class="col-md-6 mb-2">
                                                            <label class="text-xs text-muted">First Name</label>
                                                            <p class="mb-0 fw-bold">{{ viewData.firstName }}</p>
                                                        </div>
                                                        <div class="col-md-6 mb-2">
                                                            <label class="text-xs text-muted">Surname</label>
                                                            <p class="mb-0 fw-bold">{{ viewData.lastName }}</p>
                                                        </div>
                                                        <div class="col-md-6 mb-2">
                                                            <label class="text-xs text-muted">Middle Name</label>
                                                            <p class="mb-0">{{ viewData.middleName || '—' }}</p>
                                                        </div>
                                                        <div class="col-md-6 mb-2">
                                                            <label class="text-xs text-muted">Date of Birth</label>
                                                            <p class="mb-0">{{ formatDate(viewData.dateOfBirth) }}</p>
                                                        </div>
                                                        <div class="col-md-6 mb-2">
                                                            <label class="text-xs text-muted">Phone</label>
                                                            <p class="mb-0">{{ viewData.phoneNo || '—' }}</p>
                                                        </div>
                                                        <div class="col-md-6 mb-2">
                                                            <label class="text-xs text-muted">Email Address</label>
                                                            <p class="mb-0">{{ viewData.emailAddress || '—' }}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Face Verification Card -->
                                    <div class="card mb-4 card-face-verify">
                                        <div class="card-header header-face-verify d-flex justify-content-between align-items-center">
                                            <h6 class="mb-0 text-dark"><i class="fas fa-user-check me-2"></i>Face Verification</h6>
                                            <button 
                                                class="btn btn-sm btn-light" 
                                                @click="compareFaces"
                                                :disabled="isComparingFaces || !canCompareFaces">
                                                <span v-if="isComparingFaces">
                                                    <i class="fas fa-spinner fa-spin me-1"></i> Comparing...
                                                </span>
                                                <span v-else>
                                                    <i class="fas fa-search me-1"></i> Compare Faces
                                                </span>
                                            </button>
                                        </div>
                                        <div class="card-body">
                                            <!-- Photos Comparison Row -->
                                            <div class="row align-items-center">
                                                <!-- Pension Photo -->
                                                <div class="col-md-4 text-center">
                                                    <div class="photo-box">
                                                        <img :src="getPhotoUrl(viewData.photoLink)" 
                                                            class="img-fluid rounded border shadow-sm comparison-photo" 
                                                            @error="handleComparisonImageError" />
                                                        <p class="mt-2 mb-0 text-muted small fw-semibold">
                                                            <i class="fas fa-camera me-1"></i>Pension Photo
                                                        </p>
                                                    </div>
                                                </div>

                                                <!-- VS / Comparison Result -->
                                                <div class="col-md-4 text-center">
                                                    <div class="comparison-result">
                                                        <!-- Not Compared Yet -->
                                                        <div v-if="!faceComparisonResult && !isComparingFaces" class="text-muted">
                                                            <i class="fas fa-arrows-alt-h fa-2x mb-2 opacity-50"></i>
                                                            <p class="mb-0 small">Click "Compare Faces" to verify</p>
                                                        </div>

                                                        <!-- Loading State -->
                                                        <div v-else-if="isComparingFaces" class="text-info">
                                                            <div class="spinner-border spinner-border-sm mb-2" role="status"></div>
                                                            <p class="mb-0 small">Analyzing faces...</p>
                                                        </div>

                                                        <!-- Result: Match -->
                                                        <div v-else-if="faceComparisonResult && faceComparisonResult.isMatch" class="result-match">
                                                            <div class="result-badge badge-match">
                                                                <i class="fas fa-check-circle fa-2x"></i>
                                                            </div>
                                                            <h4 class="mb-1 fw-bold text-success">{{ faceComparisonResult.confidence.toFixed(1) }}%</h4>
                                                            <p class="mb-0 text-success fw-semibold">MATCH</p>
                                                            <small class="text-muted">Same Person</small>
                                                        </div>

                                                        <!-- Result: Mismatch -->
                                                        <div v-else-if="faceComparisonResult && !faceComparisonResult.isMatch" class="result-mismatch">
                                                            <div class="result-badge badge-mismatch">
                                                                <i class="fas fa-times-circle fa-2x"></i>
                                                            </div>
                                                            <h4 class="mb-1 fw-bold text-danger">{{ faceComparisonResult.confidence.toFixed(1) }}%</h4>
                                                            <p class="mb-0 text-danger fw-semibold">MISMATCH</p>
                                                            <small class="text-muted">Different Person</small>
                                                        </div>

                                                        <!-- Error State -->
                                                        <div v-else-if="faceComparisonError" class="text-warning">
                                                            <i class="fas fa-exclamation-triangle fa-2x mb-2"></i>
                                                            <p class="mb-0 small">{{ faceComparisonError }}</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Verified Photo (BVN/NIN) -->
                                                <div class="col-md-4 text-center">
                                                    <div class="photo-box">
                                                        <img :src="getPhotoUrl(viewData.verifiedPhoto)" 
                                                            class="img-fluid rounded border shadow-sm comparison-photo" 
                                                            @error="handleComparisonImageError" />
                                                        <p class="mt-2 mb-0 text-muted small fw-semibold">
                                                            <i class="fas fa-id-card me-1"></i>Verified Photo
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Comparison Details -->
                                            <div v-if="faceComparisonResult" class="mt-4 pt-3 border-top">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <div class="d-flex align-items-center">
                                                            <span class="text-muted small me-2">Confidence:</span>
                                                            <div class="progress flex-grow-1" style="height: 8px;">
                                                                <div class="progress-bar" 
                                                                    :class="faceComparisonResult.isMatch ? 'bg-success' : 'bg-danger'"
                                                                    :style="{ width: faceComparisonResult.confidence + '%' }">
                                                                </div>
                                                            </div>
                                                            <span class="ms-2 small fw-bold">{{ faceComparisonResult.confidence.toFixed(1) }}%</span>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 text-center">
                                                        <span class="text-muted small">Threshold: </span>
                                                        <span class="fw-bold">{{ faceComparisonThreshold }}%</span>
                                                    </div>
                                                    <div class="col-md-4 text-end">
                                                        <span class="text-muted small">Compared: </span>
                                                        <span class="small">{{ faceComparisonResult.timestamp }}</span>
                                                    </div>
                                                </div>

                                                <!-- Auto-flag Warning -->
                                                <div v-if="!faceComparisonResult.isMatch" class="alert alert-danger mt-3 mb-0 d-flex align-items-center">
                                                    <i class="fas fa-exclamation-triangle me-2"></i>
                                                    <div class="flex-grow-1">
                                                        <strong>Identity Mismatch Detected!</strong> 
                                                        This pensioner has been flagged as "Suspicious" for review.
                                                    </div>
                                                    <button class="btn btn-sm btn-outline-danger" @click="showFaceVerifyDetailsModal = true">
                                                        <i class="fas fa-eye me-1"></i> View Details
                                                    </button>
                                                </div>

                                                <!-- Success Message -->
                                                <div v-else class="alert alert-success mt-3 mb-0 d-flex align-items-center">
                                                    <i class="fas fa-check-circle me-2"></i>
                                                    <div>
                                                        <strong>Identity Verified!</strong> 
                                                        The pension photo matches the BVN photo with high confidence.
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- No Verified Photo Warning -->
                                            <div v-if="!viewData.verifiedPhoto" class="alert alert-warning mt-3 mb-0">
                                                <i class="fas fa-info-circle me-2"></i>
                                                <strong>Verified photo not available.</strong> Face comparison requires both pension photo and verified (BVN/NIN) photo.
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Personal Information -->
                                    <div class="card mb-4">
                                        <div class="card-header">
                                            <h6 class="mb-0"><i class="fas fa-user me-2"></i>Personal Information</h6>
                                        </div>
                                        <div class="card-body">
                                            <div class="table-responsive">
                                                <table class="table table-sm align-items-center">
                                                    <tbody>
                                                        <tr>
                                                            <td width="30%" class="bg-light"><strong>First Name</strong></td>
                                                            <td>{{ viewData.firstName }}</td>
                                                            <td width="20%" class="bg-light"><strong>Surname</strong></td>
                                                            <td>{{ viewData.lastName }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="bg-light"><strong>Other Name(s)</strong></td>
                                                            <td>{{ viewData.middleName || '—' }}</td>
                                                            <td class="bg-light"><strong>Date of Birth</strong></td>
                                                            <td>{{ formatDate(viewData.dateOfBirth) }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="bg-light"><strong>Permanent Address</strong></td>
                                                            <td colspan="3">{{ viewData.address || '—' }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="bg-light"><strong>Gender</strong></td>
                                                            <td>{{ viewData.gender || '—' }}</td>
                                                            <td class="bg-light"><strong>State of Origin</strong></td>
                                                            <td>Katsina</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="bg-light"><strong>Bank Name</strong></td>
                                                            <td>{{ viewData.bankName || '—' }}</td>
                                                            <td class="bg-light"><strong>LGA</strong></td>
                                                            <td>{{ viewData.lga || '—' }}</td>
                                                </tr>
                                                <tr> 
                                                            <td class="bg-light"><strong>GSM Number</strong></td>
                                                            <td>{{ viewData.phoneNo || '—' }}</td>
                                                            <td class="bg-light"><strong>Marital Status</strong></td>
                                                            <td>{{ viewData.maritalStatus || '—' }}</td>
                                                </tr>
                                                        <tr>
                                                            <td class="bg-light"><strong>Account Number</strong></td>
                                                            <td>{{ viewData.accountNumber || '—' }}</td>
                                                            <td class="bg-light"><strong>Email Address</strong></td>
                                                            <td>{{ viewData.emailAddress || '—' }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                                    <!-- Next of Kin -->
                                    <div class="card mb-4">
                                        <div class="card-header">
                                            <h6 class="mb-0"><i class="fas fa-users me-2"></i>Next of Kin Details</h6>
                                </div>
                                        <div class="card-body">
                                    <div class="row">
                                                <div class="col-md-6 mb-2">
                                                    <label class="text-xs text-muted">Name</label>
                                                    <p class="mb-0 fw-bold">{{ viewData.nokFirstName }} {{ viewData.nokLastName }}</p>
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <label class="text-xs text-muted">Relationship</label>
                                                    <p class="mb-0">{{ viewData.nokRelationship || '—' }}</p>
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <label class="text-xs text-muted">Address</label>
                                                    <p class="mb-0">{{ viewData.nokAddress || '—' }}</p>
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <label class="text-xs text-muted">Phone</label>
                                                    <p class="mb-0">{{ viewData.nokPhone || '—' }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Documents -->
                                    <div class="card mb-4" v-if="userClass === 'admin' || userClass === 'superadmin'">
                                        <div class="card-header">
                                            <h6 class="mb-0"><i class="fas fa-folder-open me-2"></i>Attached Documents</h6>
                                        </div>
                                        <div class="card-body">
                                            <div class="row" v-if="files.length > 0">
                                        <div class="col-md-4" v-for="doc in files" :key="doc.id">
                                                    <div class="document-card border rounded p-3 mb-3 text-center" @click="openDoc(doc.name)">
                                                        <i class="fas fa-file-pdf text-danger fa-2x mb-2"></i>
                                                        <p class="mb-0 small fw-bold">{{ doc.name }}</p>
                                                        <span class="badge bg-light text-dark">{{ doc.type }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else class="text-center py-4">
                                                <i class="fas fa-folder-open text-muted fa-3x mb-2"></i>
                                                <p class="text-muted mb-0">No documents attached</p>
                                           </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Loading State -->
                    <div class="card" v-else-if="isLoading === true && message === ''">
                        <div class="card-body text-center py-5">
                            <vsud-spinner></vsud-spinner>
                            <p class="mt-3 text-muted">Loading pensioner details...</p>
                        </div>
                    </div>

                    <!-- Error State -->
                    <div class="card" v-else>
                        <div class="card-body">
                            <vsud-nodata :message="message"></vsud-nodata>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- Teleport modals to body to escape main-content stacking context -->
    <Teleport to="body">
        <!-- Change Step Modal -->
        <div class="modal fade" :class="{ 'show d-block': showChangeStepModal }" tabindex="-1" v-if="showChangeStepModal">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Change Step</h5>
                        <button type="button" class="btn-close" @click="showChangeStepModal = false"></button>
                    </div>
                    <div class="modal-body">
                        <p>You are about to change <strong>{{ viewData.firstName }} {{ viewData.lastName }}</strong>'s enrollment step. You can always reverse this decision.</p>
                        <div class="d-grid gap-2">
                            <button class="btn bg-gradient-danger" @click="changeStep('pending')">
                                <i class="fas fa-times-circle me-1"></i> Set Pending
                            </button>
                            <button class="btn bg-gradient-success" @click="changeStep('completed')">
                                <i class="fas fa-check-circle me-1"></i> Set Completed
                            </button>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="showChangeStepModal = false">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade show" v-if="showChangeStepModal" @click="showChangeStepModal = false"></div>

        <!-- Change Sub-Status Modal -->
        <div class="modal fade" :class="{ 'show d-block': showChangeSubStatusModal }" tabindex="-1" v-if="showChangeSubStatusModal">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Change Sub Status</h5>
                        <button type="button" class="btn-close" @click="showChangeSubStatusModal = false"></button>
                    </div>
                    <div class="modal-body">
                        <p>You are about to change <strong>{{ viewData.firstName }} {{ viewData.lastName }}</strong>'s enrollment sub status. You can always reverse this decision.</p>
                        <div class="mb-3">
                            <label class="form-label">Sub Status</label>
                            <select class="form-control" v-model="selectedSubStatus">
                                <option value="valid">Valid</option>
                                <option value="incomplete">Incomplete</option>
                                <option value="discrepancy">Discrepancy</option>
                                <option value="suspicious">Suspicious</option>
                                <option value="not_on_payroll">Not on Payroll</option>
                            </select>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="showChangeSubStatusModal = false">Cancel</button>
                        <button type="button" class="btn bg-gradient-info" @click="changeSubStatus">Submit</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade show" v-if="showChangeSubStatusModal" @click="showChangeSubStatusModal = false"></div>

        <!-- Invalidate BVN Modal -->
        <div class="modal fade" :class="{ 'show d-block': showInvalidateBvnModal }" tabindex="-1" v-if="showInvalidateBvnModal">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header bg-danger">
                        <h5 class="modal-title text-white">Invalidate BVN</h5>
                        <button type="button" class="btn-close btn-close-white" @click="showInvalidateBvnModal = false"></button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-warning">
                            <i class="fas fa-exclamation-triangle me-1"></i>
                            <strong>Warning:</strong> This action will invalidate the BVN for this pensioner.
                        </div>
                        <p>Are you sure you want to invalidate BVN: <strong>{{ viewData.bvn }}</strong>?</p>
                        <div class="mb-3">
                            <label class="form-label">Reason for invalidation</label>
                            <textarea class="form-control" v-model="invalidateBvnReason" rows="3" placeholder="Enter reason..."></textarea>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="showInvalidateBvnModal = false">Cancel</button>
                        <button type="button" class="btn btn-danger" @click="invalidateBvn" :disabled="!invalidateBvnReason">
                            Invalidate BVN
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade show" v-if="showInvalidateBvnModal" @click="showInvalidateBvnModal = false"></div>

    </Teleport>
</template>

<script>
import VsudButton from "@/components/VsudButton.vue";
import VsudAlert from "@/components/VsudAlert.vue";
import VsudSpinner from "@/components/VsudSpinner.vue";
import VsudNodata from "@/components/VsudNodata.vue";
import AuthService from '@/services/auth.service.js';
import imgDef from "@/assets/img/team-5.png";
import VsudBadge from "@/components/VsudBadge.vue";
import moment from "moment";

export default {
    name: "view-beneficiary",
    data() {
        return {
            id: this.$route.params.id,
            activeView: this.$route.query.view || 'summary',
            imgDef,
            viewData: {},
            files: [],
            isLoading: false,
            isDocLoading: false,
            isSubmitted: false,
            message: '',
            alertMessage: '',
            alertColor: 'success',
            userClass: '',
            // Modals
            showChangeStepModal: false,
            showChangeSubStatusModal: false,
            showInvalidateBvnModal: false,
            showFaceVerifyDetailsModal: false,
            selectedSubStatus: 'valid',
            invalidateBvnReason: '',
            // Face Comparison (runs server-side via the API)
            isComparingFaces: false,
            faceComparisonResult: null,
            faceComparisonError: null,
            faceComparisonThreshold: 75, // Minimum confidence for a match
        }
    },

    components: {
        VsudButton,
        VsudSpinner,
        VsudNodata,
        VsudAlert,
        VsudBadge
    },

    computed: {
        canCompareFaces() {
            return this.viewData.photoLink && this.viewData.verifiedPhoto;
        },
        primaryPhoto() {
            // Use photo_link if available, otherwise fallback to verified_photo
            return this.viewData.photoLink || this.viewData.verifiedPhoto;
        }
    },

    created() {
        this.getDetails();
        this.getUserClass();
        this.moment = moment;
    },

    methods: {
        setActiveView(view) {
            this.activeView = view;
            this.$router.replace({ query: { view } });
        },

        async getDetails() {
            this.isLoading = true;
            try {
                const response = await AuthService.getSinglePensioners(this.id);
                this.viewData = response.data;
                this.files = this.viewData?.files || [];
            } catch (error) {
                console.log(error);
                this.message = error.message;
            } finally {
                this.isLoading = false;
            }
        },

        getUserClass() {
            if (this.$store.getters.isLoggedIn) {
                this.userClass = this.$store.getters.getUser.primaryRole.name;
            }
        },
        
        cleanImg(img) {
            return (img && img !== null && img !== '') ? img : '';
        },

        getPhotoUrl(photoLink) {
            // Check if photoLink is valid
            if (photoLink && photoLink !== null && photoLink !== '' && photoLink !== 'null') {
                return photoLink;
            }
            // Return default image
            return this.imgDef;
        },

        handleImageError(event) {
            const failedSrc = event.target.src;
            // If photoLink failed and verifiedPhoto exists and is different, try it as fallback
            if (this.viewData?.verifiedPhoto && failedSrc !== this.viewData.verifiedPhoto && failedSrc !== this.imgDef) {
                event.target.src = this.viewData.verifiedPhoto;
            } else {
                // Final fallback to default image
                event.target.src = this.imgDef;
            }
        },

        handleComparisonImageError(event) {
            // For face comparison images, don't fallback to verifiedPhoto - just use placeholder
            event.target.src = this.imgDef;
        },

        renderStatus(status, type = 'status') {
            let text = 'Verified';
            let color = 'success';
            if (status === 'pending' || status !== 'completed') {
                color = 'danger';
                text = 'Not Verified';
            }
            return type === 'status' ? text : color;
        },

        getSubStatusColor(subStatus) {
            const colors = {
                'valid': 'success',
                'incomplete': 'warning',
                'discrepancy': 'danger',
                'suspicious': 'dark',
                'not_on_payroll': 'secondary'
            };
            return colors[subStatus] || 'secondary';
        },

        formatSubStatus(subStatus) {
            const labels = {
                'valid': 'Valid',
                'incomplete': 'Incomplete',
                'discrepancy': 'Discrepancy',
                'suspicious': 'Suspicious',
                'not_on_payroll': 'Not on Payroll'
            };
            return labels[subStatus] || 'Pending';
        },

        formatDate(date) {
            if (!date) return '—';
            return moment(date).format('DD-MM-YYYY');
        },

        formatCurrency(amount) {
            if (!amount) return '0.00';
            return parseFloat(amount).toLocaleString('en-NG', { minimumFractionDigits: 2 });
        },

        getPensionId(data) {
            if (!data) return null;
            return data.pensionId || data.uniquePensionerId || data.unique_pensioner_id || null;
        },

        openDoc(name) {
            const doc = this.files.find(f => f.name === name);
            if (doc && doc.uri) {
                window.open(doc.uri, '_blank');
            }
        },

        printSummary() {
            // Create a printable version
            const printContent = document.getElementById('printable-summary');
            if (printContent) {
                const printWindow = window.open('', '_blank');
                printWindow.document.write(`
                    <html>
                    <head>
                        <title>Pensioner Summary - ${this.viewData.firstName} ${this.viewData.lastName}</title>
                        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css" rel="stylesheet">
                        <style>
                            body { padding: 20px; font-size: 12px; }
                            .print-header { display: block !important; }
                            .card-header { display: none; }
                            .section-title { background: #333 !important; color: white !important; }
                            @media print {
                                .no-print { display: none !important; }
                            }
                        </style>
                    </head>
                    <body>
                        ${printContent.innerHTML}
                    </body>
                    </html>
                `);
                printWindow.document.close();
                printWindow.print();
            }
        },

        generateAcknowledgementSlip() {
            const printWindow = window.open('', '_blank');
            printWindow.document.write(`
                <html>
                <head>
                    <title>Acknowledgement Slip - ${this.getPensionId(this.viewData) || 'N/A'}</title>
                    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css" rel="stylesheet">
                    <style>
                        body { padding: 40px; font-size: 14px; }
                        .header { text-align: center; margin-bottom: 30px; }
                        .details { margin-bottom: 20px; }
                        .signature-line { margin-top: 50px; border-top: 1px solid #333; width: 200px; }
                    </style>
                </head>
                <body>
                    <div class="header">
                        <h3>KATSINA STATE GOVERNMENT</h3>
                        <p>State and Local Government Pension Digital Verification Exercise</p>
                        <h4>ACKNOWLEDGEMENT SLIP</h4>
                        <hr>
                    </div>
                    <div class="details">
                        <p><strong>Pension ID:</strong> ${this.getPensionId(this.viewData) || 'N/A'}</p>
                        <p><strong>Name:</strong> ${this.viewData.firstName} ${this.viewData.lastName}</p>
                        <p><strong>BVN:</strong> ${this.viewData.bvn || 'N/A'}</p>
                        <p><strong>Phone:</strong> ${this.viewData.phoneNo || 'N/A'}</p>
                        <p><strong>Monthly Pension:</strong> ₦${this.formatCurrency(this.viewData.monthlyPension)}</p>
                        <p><strong>Verification Status:</strong> ${this.renderStatus(this.viewData.status)}</p>
                        <p><strong>Date:</strong> ${moment().format('DD-MM-YYYY')}</p>
                    </div>
                    <div class="signature-line">
                        <p class="text-center small">Officer's Signature</p>
                    </div>
                </body>
                </html>
            `);
            printWindow.document.close();
            printWindow.print();
        },

        async changeStep(step) {
            try {
                const uuid = this.viewData.id || this.viewData.uuid || this.id;
                await AuthService.updatePensionerStatus(uuid, { status: step });
                
                // Update local data
                this.viewData.status = step;
                
                this.alertMessage = `Status changed to ${step} successfully.`;
                this.alertColor = 'success';
                this.isSubmitted = true;
                this.showChangeStepModal = false;
            } catch (error) {
                console.error('Error updating status:', error);
                this.alertMessage = `Failed to update status: ${error.message || 'Please try again.'}`;
                this.alertColor = 'danger';
                this.isSubmitted = true;
                AuthService.CheckResponseError(error);
            }
            setTimeout(() => { this.isSubmitted = false; }, 3000);
        },

        async changeSubStatus() {
            try {
                const uuid = this.viewData.id || this.viewData.uuid || this.id;
                // API expects uppercase: VALID, INCOMPLETE, DISCREPANCY, SUSPICIOUS, NOT_ON_PAYROLL
                const subStatusValue = this.selectedSubStatus.toUpperCase();
                
                await AuthService.updatePensionerSubStatus(uuid, { sub_status: subStatusValue });
                
                // Update local data
                this.viewData.subStatus = this.selectedSubStatus;
                
                this.alertMessage = `Sub-status changed to ${this.formatSubStatus(this.selectedSubStatus)} successfully.`;
                this.alertColor = 'success';
                this.isSubmitted = true;
                this.showChangeSubStatusModal = false;
            } catch (error) {
                console.error('Error updating sub-status:', error);
                this.alertMessage = `Failed to update sub-status: ${error.message || 'Please try again.'}`;
                this.alertColor = 'danger';
                this.isSubmitted = true;
                AuthService.CheckResponseError(error);
            }
            setTimeout(() => { this.isSubmitted = false; }, 3000);
        },

        async invalidateBvn() {
            // Note: No endpoint for BVN invalidation in current API docs
            // This will update sub-status to SUSPICIOUS as a workaround
            try {
                const uuid = this.viewData.id || this.viewData.uuid || this.id;
                await AuthService.updatePensionerSubStatus(uuid, { 
                    sub_status: 'SUSPICIOUS'
                });
                
                this.viewData.subStatus = 'suspicious';
                
                this.alertMessage = `BVN flagged as suspicious. Reason: ${this.invalidateBvnReason}`;
                this.alertColor = 'warning';
                this.isSubmitted = true;
                this.showInvalidateBvnModal = false;
                this.invalidateBvnReason = '';
            } catch (error) {
                console.error('Error invalidating BVN:', error);
                this.alertMessage = `Failed to invalidate BVN: ${error.message || 'Please try again.'}`;
                this.alertColor = 'danger';
                this.isSubmitted = true;
                AuthService.CheckResponseError(error);
            }
            setTimeout(() => { this.isSubmitted = false; }, 3000);
        },

        /**
         * Face++ Face Comparison
         * Compares pension photo with BVN photo to verify identity
         */
        async compareFaces() {
            if (!this.canCompareFaces) {
                this.faceComparisonError = 'Both pension photo and BVN photo are required for comparison.';
                return;
            }

            this.isComparingFaces = true;
            this.faceComparisonResult = null;
            this.faceComparisonError = null;

            try {
                // Face++ comparison runs server-side (avoids browser CORS and keeps
                // the API secret off the client). Backend returns { data: {...} }.
                const uuid = this.viewData.id || this.viewData.uuid || this.id;
                const res = await AuthService.faceCompare(uuid);
                const result = res.data || {};

                const confidence = Number(result.confidence) || 0;
                const isMatch = !!result.is_match;
                this.faceComparisonThreshold = result.threshold || this.faceComparisonThreshold;

                this.faceComparisonResult = {
                    confidence: confidence,
                    isMatch: isMatch,
                    threshold: this.faceComparisonThreshold,
                    timestamp: moment().format('DD-MM-YYYY HH:mm:ss'),
                    rawResponse: result
                };

                // Auto-flag if mismatch detected
                if (!isMatch) {
                    await this.autoFlagSuspicious(confidence);
                }

                // Show success/failure alert
                if (isMatch) {
                    this.alertMessage = `Face verification passed! Confidence: ${confidence.toFixed(1)}%`;
                    this.alertColor = 'success';
                } else {
                    this.alertMessage = `Face mismatch detected! Confidence: ${confidence.toFixed(1)}%. Pensioner flagged as suspicious.`;
                    this.alertColor = 'danger';
                }
                this.isSubmitted = true;
                setTimeout(() => { this.isSubmitted = false; }, 5000);

            } catch (error) {
                console.error('Face comparison error:', error);
                const apiMsg = error.response?.data?.message || error.message;
                this.faceComparisonError = this.getFriendlyErrorMessage(apiMsg);
                this.alertMessage = `Face comparison failed: ${this.faceComparisonError}`;
                this.alertColor = 'warning';
                this.isSubmitted = true;
                setTimeout(() => { this.isSubmitted = false; }, 5000);
            } finally {
                this.isComparingFaces = false;
            }
        },

        /**
         * Auto-flag pensioner as suspicious when face mismatch is detected
         */
        async autoFlagSuspicious(confidence) {
            // Update local state immediately
            this.viewData.subStatus = 'suspicious';
            this.viewData.faceVerificationScore = confidence;
            this.viewData.faceVerificationDate = moment().format();

            // Call API to update pensioner sub-status to SUSPICIOUS
            try {
                const uuid = this.viewData.id || this.viewData.uuid || this.id;
                await AuthService.updatePensionerSubStatus(uuid, {
                    sub_status: 'SUSPICIOUS'
                });
                console.log(`Pensioner ${this.id} auto-flagged as suspicious. Face match confidence: ${confidence.toFixed(1)}%`);
            } catch (error) {
                console.error('Failed to auto-flag pensioner:', error);
                // Don't show error to user - the local state is already updated
            }
        },

        /**
         * Get user-friendly error message from Face++ API errors
         */
        getFriendlyErrorMessage(errorMessage) {
            const errorMap = {
                'INVALID_IMAGE_URL': 'One or both image URLs are invalid or inaccessible.',
                'IMAGE_DOWNLOAD_TIMEOUT': 'Failed to download images. Please check the URLs.',
                'NO_FACE_DETECTED': 'No face detected in one or both images.',
                'COEXISTENCE_ERROR': 'API parameter error. Please contact support.',
                'AUTHORIZATION_ERROR': 'API authentication failed. Please check credentials.',
                'CONCURRENCY_LIMIT_EXCEEDED': 'Too many requests. Please try again later.',
                'IMAGE_ERROR_UNSUPPORTED_FORMAT': 'Unsupported image format. Use JPG, PNG, or BMP.'
            };

            for (const [key, message] of Object.entries(errorMap)) {
                if (errorMessage.includes(key)) {
                    return message;
                }
            }
            return errorMessage || 'Unknown error occurred during face comparison.';
        }
    }
};
</script>

<style scoped>
/* Header Card Styling */
.header-card {
    border-radius: 1rem !important;
    border: none;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
}

.header-card .card-body {
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
}

.header-card .btn-group .btn {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    font-weight: 500;
    border-radius: 0;
}

.header-card .btn-group .btn:first-child {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
}

.header-card .btn-group .btn:last-child {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
}

.header-card .btn-outline-secondary {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    font-weight: 500;
    border-radius: 0.5rem;
}

.gap-2 {
    gap: 0.5rem;
}

.print-header {
    display: none;
}

@media print {
    .print-header {
        display: block !important;
    }
    .no-print {
        display: none !important;
    }
}

.avatar {
    width: 60px;
    height: 60px;
    object-fit: cover;
}

.avatar-lg {
    width: 56px;
    height: 56px;
}

/* Section Title Styles - Calm Professional Colors */
.section-title {
    font-size: 0.875rem;
    margin: 0;
    font-weight: 600;
}

.section-personal {
    background: linear-gradient(135deg, #475569 0%, #64748b 100%);
}

.section-banking {
    background: linear-gradient(135deg, #0d9488 0%, #14b8a6 100%);
}

.section-employment {
    background: linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%);
}

.section-nok {
    background: linear-gradient(135deg, #6366f1 0%, #818cf8 100%);
}

/* BVN Card Header */
.header-bvn {
    background: linear-gradient(135deg, #0284c7 0%, #0ea5e9 100%);
    border-radius: 0.75rem 0.75rem 0 0;
}

.card-bvn {
    border-radius: 0.75rem;
    overflow: hidden;
    border: none;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.info-section .table td {
    padding: 0.5rem;
    font-size: 0.8125rem;
}

.info-section .table-responsive {
    border-radius: 0 0 0.5rem 0.5rem;
    overflow: hidden;
}

.document-card {
        cursor: pointer;
    transition: all 0.2s ease;
}

.document-card:hover {
    background-color: #f8f9fa;
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.btn-xs {
    padding: 0.25rem 0.5rem;
    font-size: 0.7rem;
}

/* Note: Modal styles moved to global scope below for Teleport compatibility */

.table-sm td {
    padding: 0.4rem 0.6rem;
}

.fw-semibold {
    font-weight: 600;
}

/* Card Styling for Details View */
.card {
    border-radius: 0.75rem;
    border: none;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.card .card-header {
    background: #f8fafc;
    border-bottom: 1px solid #e5e7eb;
    padding: 1rem 1.25rem;
    border-radius: 0.75rem 0.75rem 0 0;
}

.card .card-header h6 {
    color: #334155;
    font-weight: 600;
}

.card .card-body {
    padding: 1.25rem;
}

/* Review Panel Card */
.card .btn.bg-gradient-success {
    background: linear-gradient(135deg, #059669 0%, #10b981 100%) !important;
}

.card .btn.bg-gradient-warning {
    background: linear-gradient(135deg, #d97706 0%, #f59e0b 100%) !important;
}

.card .btn.bg-gradient-info {
    background: linear-gradient(135deg, #0284c7 0%, #0ea5e9 100%) !important;
}

.card .btn.bg-gradient-dark {
    background: linear-gradient(135deg, #475569 0%, #64748b 100%) !important;
}

/* Table styling */
.table {
    margin-bottom: 0;
}

.table td.bg-light {
    background-color: #f8fafc !important;
}

.table tr:last-child td {
    border-bottom: none;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .header-card .card-body {
        padding: 1rem !important;
    }
    
    .header-card .btn-group .btn,
    .header-card .btn-outline-secondary {
        padding: 0.4rem 0.75rem;
        font-size: 0.8rem;
    }
}

/* Face Verification Card Styles - Mature Professional Colors */
.card-face-verify {
    border-radius: 0.75rem;
    overflow: hidden;
    border: none;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.header-face-verify {
    background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
    border-radius: 0.75rem 0.75rem 0 0;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid #cbd5e1;
}

.header-face-verify .btn-light {
    background: #3b82f6;
    color: #ffffff;
    border: none;
    font-weight: 500;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    transition: all 0.2s ease;
}

.header-face-verify .btn-light:hover:not(:disabled) {
    background: #2563eb;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.35);
}

.header-face-verify .btn-light:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    background: #94a3b8;
}

.comparison-photo {
    width: 140px;
    height: 140px;
    object-fit: cover;
    border: 3px solid #e5e7eb;
    transition: all 0.3s ease;
}

.photo-box:hover .comparison-photo {
    border-color: #64748b;
    box-shadow: 0 4px 12px rgba(100, 116, 139, 0.3);
}

.comparison-result {
    min-height: 140px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.result-badge {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.5rem;
}

.badge-match {
    background: linear-gradient(135deg, #059669 0%, #10b981 100%);
    color: #ffffff;
    box-shadow: 0 4px 15px rgba(5, 150, 105, 0.35);
}

.badge-mismatch {
    background: linear-gradient(135deg, #b91c1c 0%, #dc2626 100%);
    color: #ffffff;
    box-shadow: 0 4px 15px rgba(185, 28, 28, 0.35);
}

.result-match {
    animation: fadeInUp 0.5s ease;
}

.result-mismatch {
    animation: fadeInUp 0.5s ease;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.card-face-verify .alert-danger {
    background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
    border: 1px solid #fca5a5;
    border-radius: 0.75rem;
    color: #991b1b;
}

.card-face-verify .alert-success {
    background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
    border: 1px solid #6ee7b7;
    border-radius: 0.75rem;
    color: #065f46;
}

.card-face-verify .alert-warning {
    background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
    border: 1px solid #fcd34d;
    border-radius: 0.75rem;
    color: #92400e;
}

.card-face-verify .progress {
    border-radius: 1rem;
    background-color: #e5e7eb;
    height: 8px;
}

.card-face-verify .progress-bar.bg-success {
    background: linear-gradient(90deg, #059669 0%, #10b981 100%) !important;
}

.card-face-verify .progress-bar.bg-danger {
    background: linear-gradient(90deg, #b91c1c 0%, #dc2626 100%) !important;
}
</style>

<!-- Global styles for Teleported modals (must be outside scoped styles) -->
<style>
/* Modal styles - must be global because Teleport renders outside component scope */
/* These z-index values MUST be higher than sidenav's z-index: 9999 */
.modal.show.d-block {
    z-index: 10050 !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    background-color: transparent !important;
}

.modal-backdrop.fade.show {
    z-index: 10040 !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    background-color: rgba(0, 0, 0, 0.5) !important;
}

/* Ensure modal content is clickable and visible */
.modal.show.d-block .modal-dialog {
    position: relative;
    z-index: 10051;
}

.modal.show.d-block .modal-content {
    background-color: #fff;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}
</style>
